var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3105 1.44531H6.68555C6.28711 1.44531 6.04688 1.35156 5.75391 1.09961L5.39648 0.806641C5.00977 0.478516 4.71094 0.373047 4.13086 0.373047H2.46094C1.43555 0.373047 0.84375 0.958984 0.84375 2.13672V3.70703H14.1504V3.26172C14.1504 2.05469 13.5293 1.44531 12.3105 1.44531ZM2.68359 11.0957H12.4863C13.5352 11.0957 14.1504 10.4863 14.1504 9.2793V4.47461H0.84375V9.2793C0.84375 10.4922 1.45898 11.0957 2.68359 11.0957Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFolder);
export default __webpack_public_path__ + "static/media/filled-folder.139a09e7337a5ecb668e229491921302.svg";
export { ForwardRef as ReactComponent };